import * as React from "react";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableContainer from "@mui/material/TableContainer";
import { OrangeTextButton } from "../../../common/OrangeTextButton";
import EditIcon from "@mui/icons-material/Edit";
import { IgnoreZone } from "./SiteAboutPageUtils/siteAboutInterfaces";

interface IgnoreZonesTableProps {
  visibleIgnoreZones: IgnoreZone[];
  onEditClick: () => void;
}

export const IgnoreZonesTable: React.FC<IgnoreZonesTableProps> = ({
  visibleIgnoreZones,
  onEditClick,
}) => {
  return (
    <div>
      <div className="w-[300px] pt-[10px] z-10">
        <OrangeTextButton
          onClick={onEditClick}
          text={
            <>
              <EditIcon fontSize="small" />
              &nbsp;Edit Ignore Zones
            </>
          }
          disabled={false}
        />
      </div>

      <div className="pl-[5px] pt-[10px]">
        <TableContainer sx={{ width: 300, maxHeight: 320, overflow: "auto" }}>
          <Table
            sx={{
              fontFamily: "Mulish",
            }}
            stickyHeader
            size="small"
          >
            {/* <TableHead>
                            <TableRow sx={{ height: 50, borderBottom: "none" }}>
                                <TableCell
                                    sx={{
                                        fontWeight: "bold",
                                        fontFamily: "Mulish",
                                        padding: "8px 8px",
                                        width: "60px",
                                        height: 40,
                                        borderBottom: "none",
                                    }}
                                >
                                    Color
                                </TableCell>
                                <TableCell
                                    sx={{
                                        fontWeight: "bold",
                                        fontFamily: "Mulish",
                                        padding: "8px 8px",
                                        height: 40,
                                        borderBottom: "none",
                                    }}
                                >
                                    Product
                                </TableCell>
                            </TableRow>
                        </TableHead> */}
            <TableBody>
              {visibleIgnoreZones.map((object: any, index: number) => {
                return (
                  <TableRow
                    key={object.id}
                    sx={{ height: 40, borderBottom: "none" }}
                  >
                    <TableCell
                      sx={{
                        padding: "8px 8px",
                        height: 40,
                        borderBottom: "none",
                      }}
                    >
                      <div
                        key={object.label}
                        style={{
                          height: 25,
                          width: 25,
                          background: `${object.line_color}`,
                          borderRadius: 4,
                          margin: "0 auto",
                        }}
                      ></div>
                    </TableCell>
                    <TableCell
                      sx={{
                        fontFamily: "Mulish",
                        padding: "8px 8px",
                        height: 40,
                        borderBottom: "none",
                      }}
                    >
                      <div>{object.label_display_name}</div>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};
